import React, { useState, useEffect } from "react";
import {
  Tabs,
  Button,
  Drawer,
  Form,
  Input,
  Select,
  Row,
  Table,
  message,
  Tooltip,
} from "antd";
import {
  CopyOutlined,
  PlayCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { VedorApiAction } from "../../_actions/vendorApi.service";

const { TabPane } = Tabs;
const { Option } = Select;

const VendorApiTabs = () => {
  const [open, setOpen] = useState(false);
  const [drawerType, setDrawerType] = useState("vendor");

  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedApi, setSelectedApi] = useState(null);

  const handleTestClick = (record) => {
    setSelectedApi(record);
    setOpenDrawer(true);
  };

  const [token, setToken] = useState("");

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (storedUser?.token) {
      // ✅ Remove "Bearer " from start
      const cleanToken = storedUser.token.replace(/^Bearer\s+/i, "");
      setToken(cleanToken);
    }
  }, []);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      let queryParams = {};
      let bodyParams = {};
      let headers = {
        "Content-Type": "application/json",
      };

      // ✅ Split params based on param_type
      selectedApi.api_fields.forEach((field) => {
        const value = values[field.field_name];

        if (field.param_type === "query") {
          queryParams[field.field_name] = value;
        } else if (field.param_type === "body") {
          bodyParams[field.field_name] = value;
        } else if (field.param_type === "header") {
          headers[field.field_name] = value;
        }
      });

      // ✅ Add token
      if (selectedApi.token) {
        headers["Authorization"] = selectedApi.token;
      }

      // ✅ Build URL with query params
      let url = selectedApi.endpoint;
      if (Object.keys(queryParams).length > 0) {
        const queryString = new URLSearchParams(queryParams).toString();
        url += `?${queryString}`;
      }

      // ✅ Fetch options
      const options = {
        method: selectedApi.method || "POST",
        headers,
      };

      // ✅ Attach body only if needed
      if (["POST", "PUT", "PATCH"].includes(selectedApi.method)) {
        options.body = JSON.stringify(bodyParams);
      }

      const res = await fetch(url, options);
      const data = await res.json();

      console.log("Response:", data);
      message.success("API Tested Successfully");
    } catch (err) {
      console.error(err);
      message.error("API Test Failed");
    }
  };

  const mapColumns = [
    { title: "Company Name", dataIndex: "company_name" },
    { title: "API Name", dataIndex: "api_name" },

    {
      title: "API URL",
      dataIndex: "endpoint",
      render: (text) => (
        <Row align="middle" style={{ gap: 8 }}>
          <span
            style={{
              maxWidth: 220,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {text}
          </span>
          <Tooltip title="Copy URL">
            <Button
              size="small"
              icon={<CopyOutlined />}
              onClick={() => {
                navigator.clipboard.writeText(text);
                message.success("API URL copied");
              }}
            />
          </Tooltip>
        </Row>
      ),
    },

    { title: "IP Address", dataIndex: "ip" },
    // { title: "Token", dataIndex: "token" },

    // ✅ Action Column
    {
      title: "Action",
      render: (_, record) => (
        <Button
          type="primary"
          icon={<PlayCircleOutlined />}
          onClick={() => handleTestClick(record)}
        >
          Test API
        </Button>
      ),
    },
  ];

  const [form] = Form.useForm();

  const [vendorList, setVendorList] = useState([]);
  const [apiList, setApiList] = useState([]);
  const [mapList, setMapList] = useState([]);

  // ================= API CALLS =================
  const listVendor = async () => {
    const res = await VedorApiAction.listVendor();
    setVendorList(res?.data || []);
  };

  const listAPIDetails = async () => {
    const res = await VedorApiAction.getApiConfigs();
    console.log("res", res.data);
    setApiList(res?.data || []);
  };

  const listMappedApis = async () => {
    const res = await VedorApiAction.listMapApiDetails();
    setMapList(res?.data || []);
  };

  useEffect(() => {
    listVendor();
    listAPIDetails();
    listMappedApis();
  }, []);

  // ================= DRAWER =================
  const showDrawer = () => setOpen(true);

  const closeDrawer = () => {
    setOpen(false);
    form.resetFields();
  };

  // ================= FORM SUBMIT =================
  const onFinish = async (values) => {
    if (drawerType === "vendor") {
      await VedorApiAction.addVendor(values);
      listVendor();
    }

    if (drawerType === "api") {
      await VedorApiAction.addAPIDetails(values);
      listAPIDetails();
    }

    if (drawerType === "map") {
      await VedorApiAction.addMapApi(values);
      listMappedApis();
    }

    closeDrawer();
  };

  // ================= TABLE COLUMNS =================
  const vendorColumns = [
    { title: "Company Name", dataIndex: "company_name" },
    { title: "Auth Person", dataIndex: "auth_person" },
    { title: "Mobile", dataIndex: "mobile_no" },
    { title: "Email", dataIndex: "email" },
    { title: "Plan", dataIndex: "plan" },
  ];

  const apiColumns = [
    {
      title: "API Name",
      dataIndex: "name",
    },
    {
      title: "API URL",
      dataIndex: "url",
      render: (text) => (
        <Row align="middle" style={{ gap: 8 }}>
          <span
            style={{
              maxWidth: 220,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {text}
          </span>
          <Tooltip title="Copy URL">
            <Button
              size="small"
              icon={<CopyOutlined />}
              onClick={() => {
                navigator.clipboard.writeText(text);
                message.success("API URL copied");
              }}
            />
          </Tooltip>
        </Row>
      ),
    },
    // {
    //   title: "Token",
    //   dataIndex: "token",
    // },
    {
      title: "Description",
      dataIndex: "description",
    },
  ];

  return (
    <>
      <Tabs
        defaultActiveKey="vendor"
        onChange={(key) => setDrawerType(key)}
        tabBarExtraContent={
          <Button type="primary" icon={<PlusOutlined />} onClick={showDrawer}>
            Add
          </Button>
        }
      >
        {/* ================= VENDOR TAB ================= */}
        <TabPane tab="Vendor" key="vendor">
          <Table
            rowKey="id"
            columns={vendorColumns}
            dataSource={vendorList}
            pagination={{ pageSize: 10 }}
          />
        </TabPane>

        {/* ================= API TAB ================= */}
        {/* <TabPane tab="API" key="api">
          <Table
            rowKey="id"
            columns={apiColumns}
            dataSource={apiList}
            pagination={{ pageSize: 10 }}
          />
        </TabPane> */}

        {/* ================= MAP API TAB ================= */}
        <TabPane tab="Map API" key="map">
          <Table
            rowKey="id"
            columns={mapColumns}
            dataSource={mapList}
            pagination={{ pageSize: 10 }}
          />
        </TabPane>
      </Tabs>

      {/* ================= DRAWER ================= */}
      <Drawer
        title={
          drawerType === "vendor"
            ? "Add Vendor"
            : drawerType === "api"
            ? "Add API"
            : "Map API"
        }
        width={420}
        open={open}
        onClose={closeDrawer}
      >
        <Form
          layout="vertical"
          form={form}
          initialValues={{ token: token }}
          onFinish={onFinish}
        >
          {/* ========== VENDOR FORM ========== */}
          {drawerType === "vendor" && (
            <>
              <Form.Item
                label="Company Name"
                name="company_name"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="GST Number"
                name="gst_no"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Authorized Person"
                name="auth_person"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Mobile Number"
                name="mobile_no"
                rules={[
                  { required: true },
                  { pattern: /^[0-9]{10}$/, message: "Invalid mobile" },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
                rules={[{ required: true, type: "email" }]}
              >
                <Input />
              </Form.Item>

              <Form.Item label="Plan" name="plan">
                <Select>
                  <Option value="1 year">1 Year</Option>
                </Select>
              </Form.Item>
            </>
          )}

          {/* ========== API FORM ========== */}
          {drawerType === "api" && (
            <>
              <Form.Item
                label="API Name"
                name="name"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="API URL"
                name="url"
                rules={[
                  { required: true, message: "API URL is required" },
                  {
                    type: "url",
                    message: "Enter a valid URL (https://...)",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              {/* <Form.Item
                label="Token"
                name="token"
                rules={[{ required: true }]}
              >
                <Input.TextArea rows={3} />
              </Form.Item> */}

              <Form.Item
                label="Description"
                name="description"
                rules={[{ required: true }]}
              >
                <Input.TextArea rows={3} />
              </Form.Item>
            </>
          )}

          {/* ========== MAP API FORM ========== */}
          {drawerType === "map" && (
            <>
              <Form.Item
                label="Company Name"
                name="vendor"
                rules={[{ required: true }]}
              >
                <Select placeholder="Select Company">
                  {vendorList.map((v) => (
                    <Option key={v.id} value={v.id}>
                      {v.company_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="API Name"
                name="api"
                rules={[{ required: true }]}
              >
                <Select placeholder="Select API">
                  {apiList.map((a) => (
                    <Option key={a.id} value={a.id}>
                      {a.api_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="IP Address"
                name="ip"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="token"
                name="token"
                rules={[{ required: true }]}
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Enter token"
                  showCount
                  maxLength={500}
                  disabled={token}
                />
              </Form.Item>
            </>
          )}

          <Row justify="end">
            <Button onClick={closeDrawer} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Row>
        </Form>
      </Drawer>
      <Drawer
        title="Test API"
        width={500}
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
      >
        {selectedApi && (
          <>
            <p>
              <b>API:</b> {selectedApi.api_name}
            </p>
            <p>
              <b>URL:</b> {selectedApi.endpoint}
            </p>

            <Form form={form} layout="vertical">
              {/* Dynamic fields (from api_fields) */}
              {selectedApi.api_fields?.map((field) => (
                <Form.Item
                  key={field.id}
                  label={field.field_name}
                  name={field.field_name}
                  rules={[
                    {
                      required: field.is_required,
                      message: `${field.field_name} is required`,
                    },
                  ]}
                >
                  <Input placeholder={`Enter ${field.field_name}`} />
                </Form.Item>
              ))}

              <Button type="primary" onClick={handleSubmit}>
                Send Request
              </Button>
            </Form>
          </>
        )}
      </Drawer>
    </>
  );
};

export default VendorApiTabs;
